import React from 'react'

import { Heading, Loader, ModalBox, useModalContext } from '@fourthwall/components'

import { SectionItem } from '../SectionItem'
import * as S from './styled'
import type { GroupedSection, Section } from './types'

type Props = {
  blockId: string
  sections?: GroupedSection[]
  onCreateLayoutSection: (sectionType: string, blockId: string, platformAppId?: string) => void
  filterSections: string[]
}

export const AddSectionModalView = ({
  blockId,
  sections,
  onCreateLayoutSection,
  filterSections,
}: Props) => {
  const { close } = useModalContext()

  const renderSectionItems = (sections: Section[]) => (
    <>
      {sections
        .filter((s) => !filterSections.includes(s.sectionType))
        .map((item) => (
          <SectionItem
            key={item.sectionType}
            section={item}
            onButtonClick={() =>
              onCreateLayoutSection(item.sectionType, blockId, item.platformAppId)
            }
          />
        ))}
    </>
  )

  return (
    <ModalBox
      maxWidth={sections?.length === 1 ? 600 : 896}
      disableScrolling
      withoutPadding
      onClose={close}
    >
      {!sections ? (
        <S.LoaderWrapper>
          <Loader size="large" />
        </S.LoaderWrapper>
      ) : (
        <S.Container>
          <S.TitleContainer>
            <Heading type="h4" weight="semibold">
              Add section
            </Heading>
          </S.TitleContainer>
          <S.Content>
            {sections.length === 1 && (
              <>
                {sections.map(({ group, sections }) => (
                  <div key={group}>{renderSectionItems(sections)}</div>
                ))}
              </>
            )}
            {sections.length > 1 && (
              <>
                {sections.map(({ group, sections }) => (
                  <div key={group}>
                    <S.SectionHeader>{group}</S.SectionHeader>
                    <S.Wrapper>{renderSectionItems(sections)}</S.Wrapper>
                  </div>
                ))}
              </>
            )}
          </S.Content>
        </S.Container>
      )}
    </ModalBox>
  )
}
